site.scrollTo = {
	init: function () {
		$('*[data-scrollto]').click(function () {
			console.log('click');
			var scrollToId = $(this).data('scrollto');
			var $element = $(scrollToId);
			var offset = $element.offset().top;
			var $body = $('body, html');
			if( $(window).width() > 992) {
				$body.animate({scrollTop: offset }, 500);
			} else {
				var extra = $('#header').height();
				$body.animate({scrollTop: offset - extra}, 500);
			}
		});
	}
};

site.inits.push('site.scrollTo.init()');
